import { useCheckPerm, useIsNewEntry } from "src/hooks";
import { useSelector } from "src/redux/hooks";
/**
 * Custom hook to determine if a logbook entry can be edited.
 *
 * @param sectionIndex - An optional number representing the index of the section to check for edit permissions.
 * @returns A boolean indicating whether the entry can be edited.
 */
export const useCanEditEntry = (sectionIndex?: number) => {
  const checkPerm = useCheckPerm();
  const isNewEntry = useIsNewEntry();
  const status = useSelector(state => state.generatorSlice.latestEntry.status);
  const { locked24SectionIndex } = useSelector(state => state.generatorSlice);
  const entryType = useSelector(
    state => state.generatorSlice.lbentry.entryType,
  );

  if (sectionIndex === locked24SectionIndex && !isNewEntry) {
    return false;
  }

  if (entryType === "none") {
    return false;
  } else if (isNewEntry) {
    return checkPerm("createentries");
  } else if (status === 0) {
    return checkPerm("createentries");
  } else {
    return checkPerm("editentries");
  }
};
